import { useEffect, useState, useRef } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import styles from "./blog_header.module.scss";
import ArrowIcon from "../../../public/editor/menu_arrow.svg";
import { capitalizeFirstLetter } from "../../../utils/capitalizeFirstLetter";
import getCommonLocales from "../../../locales/locales_common";
import { HandySvg } from "handy-svg";

function BlogHeader({ categories, isMainPage }) {
  const router = useRouter();
  const { locale } = router;
  const dictionary = getCommonLocales(locale);
  const selectedCategory = router.asPath.split("/")[3]?.split("%20").join(" ");
  const [activeCategory, setActiveCategory] = useState(selectedCategory);
  const [navIsShown, setNavIsShown] = useState(false);
  const btnRef = useRef();

  const resizeWindow = () => setNavIsShown(false);

  useEffect(() => {
    resizeWindow();
    const clickHandler = (e) => {
      if (
        !e.target.matches(".header_menu") &&
        !e.target.matches(".header_menu *") &&
        !e.target.matches(".adaptive-btn") &&
        !e.target.matches(".adaptive-btn *")
      ) {
        setNavIsShown(false);
      }
    };

    document.body.addEventListener("mousedown", clickHandler);
    window.addEventListener("resize", resizeWindow);
    return () => {
      window.removeEventListener("resize", resizeWindow);
      document.body.removeEventListener("mousedown", clickHandler);
    };
  }, []);

  const showNavHandler = () => {
    setNavIsShown(!navIsShown);
  };

  return (
    <header className={styles["header-block"]}>
      <div className={styles.header}>
        <button
          ref={btnRef}
          onClick={showNavHandler}
          className={`adaptive-btn ${styles["adaptive-btn"]}`}
          aria-label="menu"
        >
          <div className={styles.burger}></div>
          <div className={styles.burger}></div>
          <div className={styles.burger}></div>
        </button>
        <div className={styles.logo}>
          <Link href="/" className={styles.logoLink}>
            <HandySvg src={"/header/color_header_logo_blog.svg"} width={130} height={38} className={styles.logo} />
          </Link>
          <span className={styles["logo-separator"]}></span>

          {isMainPage ?
            <h1 className={styles["logo-text"]}>
              {dictionary["Blog"] || "Blog"}
            </h1>
            :
            <Link href="/blog" className={styles["logo-text"]}>
              {dictionary["Blog"] || "Blog"}
            </Link>
          }

        </div>
        <div className={styles.filter}>
          <nav className={styles["filter-nav"]}>
            <ul className={styles["filter-list"]}>
              {categories.filter(item => item !== undefined).map((item) => (
                <Link legacyBehavior key={item} href={`/blog/categories/${item}`}>
                  <li
                    onClick={() => setActiveCategory(item)}
                    className={activeCategory === item ? styles["active-link"] : styles["filter-item"]}
                  >
                    {dictionary[capitalizeFirstLetter(item)] || dictionary["Tips&Ideas"] || item}
                  </li>
                </Link>
              ))
              }
            </ul>
          </nav>
          <nav className={`header_menu ${styles.header_menu} ${navIsShown ? styles.open : styles.close}`}          >
            {router.pathname.split("/").includes("categories") && (
              <Link legacyBehavior href={`/blog`}>
                <a onClick={() => setNavIsShown(false)} className={styles["adaptive-link"]}>
                  <ArrowIcon className={styles["adaptive-link-icon"]} />
                  all articles
                </a>
              </Link>
            )}
            {categories.filter(item => item !== undefined).map((item) => {
              return (
                <Link legacyBehavior key={item} href={`/blog/categories/${item}`}>
                  <a
                    onClick={() => {
                      setNavIsShown(false); setActiveCategory(item);
                    }}
                    className={activeCategory === item ? styles["active-adaptive-link"] : styles["adaptive-link"]}
                  >
                    {dictionary[capitalizeFirstLetter(item)] || dictionary["Tips&Ideas"] || item}
                  </a>
                </Link>
              );
            })}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default BlogHeader;
